import { useState } from "react";

import LabelControl from "/src/components/common/Form/Wrapper/LabelControl";
import Pill from "/src/components/common/Form/Pill";

function shouldRender(options) {
  return options?.length > 0;
}

function Component({ className, formValues, isMulti, labelControlProps, onChange, options, optionFilter, value }) {

  const [isOpen, setIsOpen] = useState(false);

  const hasValue = () => {
    if (Array.isArray(value) && value.length > 0) {
      return true;
    }
    else if (value) {
      return true;
    }
    else {
      return false;
    }
  }

  const handleChange = (newValue) => {
    if (typeof onChange === "function") {
      onChange(newValue);
    }
    if (!isMulti) {
      setIsOpen(false);
    }
  };

  const handleFilter = (item) => {
    if (typeof optionFilter === "function") {
      return optionFilter(item, formValues);
    }
    return true;
  }

  if (shouldRender(options)) {
    return (
      <LabelControl {...labelControlProps}>
        <Pill
          isMulti={isMulti}
          options={options.filter(handleFilter)}
          onChange={handleChange}
          value={value}
        />
      </LabelControl>
    );
  }

  return null;

}

export default Component;
